<template>
  <table>
    <colgroup>
       <col style="width: 24px">
       <col>
       <col style="width: 64px">
       <col style="width: 78px">
    </colgroup>
    <thead>
        <tr>
          <th>Selection</th>
          <th>Item</th>
          <!-- <th>Category</th> -->
          <th>Time</th>
          <th>Action</th>  
        </tr>
    </thead>
    <tbody>
    <tr v-for="device in $store.getters.deviceList" :key="device.id" @click="$store.commit('toggleSelection', device)"
    :class="{ selectedRow: device.selected }">
        <td>
          <i v-if="device.selected" class="fa-solid fa-square-check"></i>
          <i v-else class="fa-regular fa-square"></i>
        </td>
        <td>{{ device.name }}</td>
        <!-- <td>{{ device.category }}</td> -->
        <td id="timePassedColumn">{{ calculatePassedDays(device) }}</td>
        <td class="buttonColumn">
          <i id="resetButton" @click="$store.dispatch('resetDeviceDate', device)" class="fa-solid fa-arrow-rotate-right actionButton"></i>
          <i id="deleteButton" @click="$store.commit('removeDevice', device)" class="fa-solid fa-trash actionButton"></i>
        </td>
    </tr>
  </tbody>


  </table>


 
</template>

<script>
import { onMounted } from 'vue'
import { useStore } from 'vuex'

export default {
  setup() {
    onMounted(() => {
      const store = useStore()

      store.dispatch('fetchDeviceListFromDB')
    })

    const calculatePassedDays = ((device) => {
      let days = Math.round((Date.now() - new Date(device.last_updated_date))/(1000*60*60*24))
      return (days!=1 ? days + " days" : days + " day")
    })

    return {
      calculatePassedDays
    }
  },
  computed: {
    listCategories() {
      let categories = new Set()

      this.$store.getters.deviceList.forEach(device => {
        categories.add(device.category)
      });

      return categories
    }
  }
}
</script>

<style>
.categoryName {
  color: #deb992;
  font-size: 0.8em;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-weight: bold;
  padding-top: 0.5em;
}

table {
  width: 100%;
  font-size: 1em;
  line-height: 1.6em;
  margin-top: 1em;
  table-layout: fixed;
  border-collapse: collapse;
}

table td {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    word-wrap: break-word;
}

table thead{
	visibility:collapse;  
}

table tr:hover{  
    /* color: white; */
    cursor: pointer;
}

#deleteButton:hover{
  color: red;
}

#resetButton:hover{
  color: #deb992;
}

.buttonColumn{
  text-align: right;
}

.actionButton{
  padding-left: 6px;
  padding-right: 6px;
  /* display: none; */
}

#timePassedColumn{
  text-align: right;
}

th, td {
	padding-left: 8px;
  padding-right: 8px
}

.selectedRow {
  color: white;
  background: #1ba098;
}
</style>